module.exports = __webpack_public_path__ + "img/at.a62b9796.svg";